/** Plantillas de página: un icono, un título y los bloques con los que empieza.
 *
 * Son datos y no código a propósito: añadir una es añadir un objeto aquí, sin tocar el editor.
 * Los bloques usan el formato de BlockNote y el texto va en línea (`content` como cadena),
 * que el editor acepta y normaliza al cargar.
 */
import type { Bloque } from './tipos'

export interface Plantilla {
  id: string
  nombre: string
  descripcion: string
  icono: string
  titulo: string
  bloques: Bloque[]
}

const p = (texto: string): Bloque => ({ type: 'paragraph', content: texto })
const h = (nivel: 1 | 2 | 3, texto: string): Bloque => ({
  type: 'heading',
  props: { level: nivel },
  content: texto,
})
const punto = (texto: string): Bloque => ({ type: 'bulletListItem', content: texto })
const tarea = (texto: string): Bloque => ({ type: 'checkListItem', content: texto })
const codigo = (texto: string): Bloque => ({ type: 'codeBlock', content: texto })

export const PLANTILLAS: Plantilla[] = [
  {
    id: 'script',
    nombre: 'Documentación de script',
    descripcion: 'Qué hace, cómo se instala y cómo se configura',
    icono: '🧩',
    titulo: 'Nombre del script',
    bloques: [
      h(2, 'Resumen'),
      p('Qué hace este script y por qué existe.'),
      h(2, 'Instalación'),
      tarea('Copiar la carpeta a resources/'),
      tarea('Añadir ensure nombre_del_script al server.cfg'),
      tarea('Importar el SQL si lo hay'),
      h(2, 'Configuración'),
      codigo('Config = {\n  Debug = false,\n}'),
      h(2, 'Comandos y permisos'),
      punto('/comando: qué hace y quién puede usarlo'),
      h(2, 'Problemas conocidos'),
      p('Nada por ahora.'),
    ],
  },
  {
    id: 'changelog',
    nombre: 'Changelog',
    descripcion: 'Registro de cambios por versión',
    icono: '📝',
    titulo: 'Changelog',
    bloques: [
      h(2, 'v1.0.0'),
      h(3, 'Añadido'),
      punto('Primera versión'),
      h(3, 'Cambiado'),
      punto(''),
      h(3, 'Corregido'),
      punto(''),
    ],
  },
  {
    id: 'normativa',
    nombre: 'Normativa interna',
    descripcion: 'Reglas, sanciones y excepciones',
    icono: '📘',
    titulo: 'Normativa',
    bloques: [
      h(1, 'Objeto'),
      p('A quién se aplica y desde cuándo.'),
      h(2, 'Normas'),
      { type: 'numberedListItem', content: 'Primera norma' },
      { type: 'numberedListItem', content: 'Segunda norma' },
      h(2, 'Sanciones'),
      p('Qué pasa si no se cumple.'),
      h(2, 'Excepciones'),
      p('Quién puede autorizarlas.'),
    ],
  },
  {
    id: 'reunion',
    nombre: 'Acta de reunión',
    descripcion: 'Asistentes, temas y acuerdos',
    icono: '🗓️',
    titulo: 'Reunión',
    bloques: [
      h(3, 'Asistentes'),
      punto(''),
      h(3, 'Orden del día'),
      { type: 'numberedListItem', content: '' },
      h(3, 'Acuerdos'),
      tarea(''),
      h(3, 'Próxima reunión'),
      p(''),
    ],
  },
  {
    id: 'tareas',
    nombre: 'Lista de tareas',
    descripcion: 'Una checklist para ir tachando',
    icono: '✅',
    titulo: 'Tareas',
    bloques: [tarea(''), tarea(''), tarea('')],
  },
]
